import "./Contacto.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

function Contacto() {
  return (
    <section className="contacto" id="contacto">

      <span className="contacto-subtitulo">
        CONTÁCTANOS
      </span>

      <h2>Estamos para ayudarte</h2>

      <p className="contacto-texto">
        Nuestro equipo está listo para brindarte toda la información
        que necesitas sobre Residencial YANNA I y ayudarte a dar el
        siguiente paso hacia tu nuevo hogar.
      </p>

      <div className="info">

        <div className="card">

          <FaPhoneAlt className="icon" />

          <h3>Teléfono</h3>

          <a href="tel:+18299623399">
            (829) 962-3399
          </a>

        </div>

        <div className="card">

          <FaEnvelope className="icon" />

          <h3>Correo electrónico</h3>

          <a href="mailto:yannelizaaybar@gmail.com">
            yannelizaaybar@gmail.com
          </a>

        </div>

        <div className="card">

          <FaMapMarkerAlt className="icon" />

          <h3>Ubicación</h3>

          <a
            href="https://maps.google.com/?q=Madre+Vieja+Sur+Residencial+Camino+del+Sol+San+Cristobal"
            target="_blank"
            rel="noopener noreferrer"
          >
            Madre Vieja Sur<br />
            Residencial Camino del Sol<br />
            San Cristóbal, República Dominicana
          </a>

        </div>

      </div>

    </section>
  );
}

export default Contacto;